import { Component, Inject } from '@angular/core';

import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { TranslateService } from '@ngx-translate/core';

import { ItemSelectionDialogData } from './models/item-selection-dialog-data';
import { SelectionType } from '@common/models/types-model';

@Component({
  selector: 'tiwp-item-selection-dialog',
  templateUrl: './item-selection-dialog.component.html',
})
export class ItemSelectionDialogComponent {
  onDisabledTooltipText = 'disabled';
  constructor(
    private translate: TranslateService,
    public dialogRef: MatDialogRef<ItemSelectionDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ItemSelectionDialogData
  ) {
    this.translate.get('common.tooltip.disabled').subscribe(
      (tooltipText: string) => (this.onDisabledTooltipText = tooltipText),
      (error) => {
        this.onDisabledTooltipText = 'disabled';
        console.error(
          '%cLanguage error: ',
          'color:black;background:red',
          error.message,
          'Key: common.tooltip.disabled'
        );
      }
    );
  }

  onClick(itemSelected: SelectionType): void {
    this.dialogRef.close(itemSelected);
  }
}
